import { SCOPE as PARENT_SCOPE } from '../types';

export const SCOPE = `${PARENT_SCOPE}.base`;
export const INIT = `${SCOPE}/INIT`;
export const SET_DIMENSION = `${SCOPE}/SET_DIMENSION`;
export const SET_MODE = `${SCOPE}/SET_MODE`;
export const SET_TRENDS_METRICS = `${SCOPE}/SET_TRENDS_METRICS`;
export const SET_FILTERS_METRICS = `${SCOPE}/SET_FILTERS_METRICS`;
export const SET_TABLE_DATA = `${SCOPE}/SET_TABLE_DATA`;
export const PERSIST_STATE = `${SCOPE}/PERSIST_STATE`;
export const SET_PERSISTED_STATE = `${SCOPE}/SET_PERSISTED_STATE`;
export const APPLY_TRENDS_SELECTED_NOC_FILTERS = `${SCOPE}/APPLY_TRENDS_SELECTED_NOC_FILTERS`;
export const UPDATE_SAVED_FILTERS_SELECTED_NOC_FILTERS = `${SCOPE}/UPDATE_SAVED_FILTERS_SELECTED_NOC_FILTERS`;
export const APPLY_FILTERS_SELECTED_NOC_FILTERS = `${SCOPE}/APPLY_FILTERS_SELECTED_NOC_FILTERS`;
export const APPLY_DRILLDOWN = `${SCOPE}/APPLY_DRILLDOWN`;
export const SAVE_THRESHOLD_CHANGE_STATUS = `${SCOPE}/SAVE_THRESHOLD_CHANGE_STATUS`;
export const SET_ALL_THRESHOLD_SELECTION = `${SCOPE}/SET_ALL_THRESHOLD_SELECTION`;
export const SET_ADMIN_PROFILE = `${SCOPE}/SET_ADMIN_PROFILE`;
export const SET_TRENDS_SORTING = `${SCOPE}/SET_TRENDS_SORTING`;
export const SET_FILTERS_SORTING = `${SCOPE}/SET_FILTERS_SORTING`;
export const SET_AUTO_SORT = `${SCOPE}/SET_AUTO_SORT`;
export const SET_REDIRECTED_FROM_NOC_TILE = `${SCOPE}/SET_REDIRECTED_FROM_NOC_TILE`;
export const FILTER_AND_APPLY_STATE = `${SCOPE}/FILTER_AND_APPLY_STATE`;
export const UPDATE_PERSISTED_NOC_STATE = `${SCOPE}/UPDATE_PERSISTED_NOC_STATE`;
